import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "opModal erroriModal" };
const _hoisted_2 = {
    key: 0,
    class: "header"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "body" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { class: "mt-2" };
const _hoisted_7 = { class: "mt-3 mw-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", { innerHTML: _ctx.title }, null, 8, _hoisted_3)
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
                class: "erroriText",
                innerHTML: _ctx.text
            }, null, 8, _hoisted_5),
            _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1));
                }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-block btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close'))),
                    ref: "okButton"
                }, " Chiudi ", 512)
            ])
        ])
    ]));
}
